import React, { useEffect, useState, useRef, useLayoutEffect } from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import PropTypes from 'prop-types';
import styles from './index.css';
import { useFixedTitle } from './hooks';
import Draggable from 'react-draggable';

const IframeVideo = ({ liveData }) => {
    const IframeVideoRef = useRef(null);
    const IframeRef = useRef(null);
    const [iframeDistance, setIframeDistance] = useState(0);
    const [isCloseFix, setIsCloseFix] = useState(false);
    const [peopleNum, setPeopleNum] = useState(0);
    let showFixed = useFixedTitle(iframeDistance);
    const handleFixedCloseClick = () => {
        setIsCloseFix(true);
    };

    const iframeVideoAutoPlay = () => {
        IframeRef.current.contentWindow.postMessage({ type: 'autoPlay' }, '*');
    };

    const newAppPlay = () => {
        const creatFun = callback => {
            const funName = `__grounds_${Number(Math.floor(Math.random() * 10000000000)).toString(36)}`;

            window[funName] = msg => {
                callback(msg);
            };

            return funName;
        };
        const __Native = {
            intercall: (appCommand, callback) => {
                const funName = creatFun(callback);

                if (window.grounds) {
                    window.grounds[appCommand](funName);
                }
            },
        };

        __Native.intercall('deviceInfo', () => {
            iframeVideoAutoPlay();
        });
    };

    const autoplayHandler = () => {
        let isWxReady = false;
        let playerReady = false;
        const isWeixin = navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1;

        if (isWeixin) {
            // 微信
            if (typeof WeixinJSBridge == 'undefined') {
                document.addEventListener(
                    'WeixinJSBridgeReady',
                    () => {
                        isWxReady = true;
                        if (playerReady) {
                            iframeVideoAutoPlay();
                        }
                    },
                    false,
                );
            } else {
                isWxReady = true;
                if (playerReady) {
                    iframeVideoAutoPlay();
                }
            }
        }
        window.addEventListener('message', e => {
            // console.log(e.data, 'iframeData');
            if (e.data.type === 'init') {
                // 如果是自动播放需要自动播放
                playerReady = true;
                if (isWeixin) {
                    if (isWxReady) {
                        iframeVideoAutoPlay();
                    }
                } else if (window.grounds) {
                    newAppPlay();
                }
            }
            if (e.data.type === 'online' && e?.data?.data?.num) {
                setPeopleNum(e.data.data.num);
            }
            // 是否是画中画判断
            if (e.data.type === 'pipChange') {
                // console.log(e.data, 'pipChange');
                if (e.data.data) {
                    setIsCloseFix(true);
                } else {
                    setIsCloseFix(false);
                }
            }
        });
    };

    useLayoutEffect(() => {
        autoplayHandler();
    }, []);

    useEffect(() => {
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        const IframeVideoTop = IframeVideoRef.current.getBoundingClientRect().top;
        const IframeVideoHeight = IframeVideoRef.current.getBoundingClientRect().height;

        setIframeDistance(IframeVideoTop + IframeVideoHeight);
    }, []);

    const handleDrag = (event, draggableData) => {
        // 处理拖动逻辑
    };

    // 数字过万处理,超过一万显示为x.x万，不足一万显示原数字,小数点后一位不使用toFixed进行四舍五入
    const formatPeopleNum = num => {
        if (num >= 10000) {
            const decimal = Math.floor(num / 1000) / 10;

            return `${decimal.toString()}万`;
        } else {
            return num.toString();
        }
    };

    useEffect(
        () => {
            if (showFixed) {
                IframeRef.current.contentWindow.postMessage({ type: 'hideSkin' }, '*');
            } else {
                IframeRef.current.contentWindow.postMessage({ type: 'showSkin' }, '*');
            }
        },
        [showFixed],
    );

    // if (isCloseFix) {
    //     showFixed = false;
    // }

    return (
        <div className={styles.liveBox}>
            <div className={styles.iframeBox} ref={IframeVideoRef}>
                <Draggable onDrag={handleDrag}>
                    <div
                        className={`${
                            showFixed && (liveData?.liveStatus === '1' || liveData?.liveStatus === '2') && !isCloseFix
                                ? styles.IframeFix
                                : styles.IframeVideo
                        }`}>
                        <iframe
                            allowFullScreen
                            ref={IframeRef}
                            scrolling="no"
                            frameBorder="0"
                            className={styles.iframe}
                            src={`https://timeline.ifeng.com/loc/proxy/https/flive.ifeng.com/video/${
                                liveData.liveId
                            }.html`}
                            // src={`https://flive.ifeng.com/video/${liveData.liveId}.html?autoplay=1`}
                        />
                        {showFixed &&
                            !isCloseFix && <div className={styles.playerFixedClose} onClick={handleFixedCloseClick} />}
                        {showFixed &&
                            !isCloseFix && (
                                <div className={styles.dragPop}>
                                    <div className={styles.dragPopText}>拖动此处移动小窗</div>
                                </div>
                            )}
                    </div>
                </Draggable>
            </div>
            <div className={styles.liveTitle}>{liveData.title}</div>
            <div className={styles.liveInfo}>
                <div className={styles.liveInfoUser}>
                    {liveData?.anchorAvatar && <img className={styles.liveInfoUserFace} src={liveData.anchorAvatar} />}
                    {liveData?.anchorName && <div className={styles.liveInfoUserName}>{liveData.anchorName}</div>}
                </div>
                {peopleNum !== 0 && (
                    <div className={styles.liveStatus}>
                        观看&nbsp;<span className={styles.liveLookNum}>{formatPeopleNum(peopleNum)}</span>
                    </div>
                )}
            </div>
        </div>
    );
};

IframeVideo.propTypes = {
    liveData: PropTypes.object,
};

export default errorBoundary(IframeVideo);
